export enum ToolInOutSourceType {
  WORK_ORDER = "WORK_ORDER",
  PETTY_WORK = "PETTY_WORK",
  AMC = "AMC",
  OTHER = "OTHER",
}
export const ToolInOutSourceTypeLabel: Record<ToolInOutSourceType, string> = {
  [ToolInOutSourceType.WORK_ORDER]: "Work Order",
  [ToolInOutSourceType.PETTY_WORK]: "Petty Work",
  [ToolInOutSourceType.AMC]: "AMC",
  [ToolInOutSourceType.OTHER]: "Other",
};
